import React, { useState } from 'react';

// Hooks
import { useDispatch } from 'react-redux';

// Actions
import { success, failure } from '~/redux/actions/snackbar-actions';
import { deleteCampaign } from '~/redux/actions/campaign-actions';

// utils
import { MESSAGES } from '~/utils/message';
import OlcButton from '~/components/General/OlcButton';

// Mui Components
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Box, CircularProgress } from '@mui/material';

// Icons
import { ContactDetailsDeleteCIcon, DetailsCrossCIcon } from '~/assets/images';

// Styles
import './styles.scss';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const ActionsModal = (props) => {
  const {
    openModal,
    handleCloseModal,
    campaignId,
    setSearch,
    getCampaigns,
    onSubmit,
    stepDelete = false,
  } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const deleteExistingCategory = async () => {
    try {
      setLoading(true);
      const response = await dispatch(deleteCampaign(campaignId));
      dispatch(success(response.data.message));
      getCampaigns();
      handleCloseModal();
      setSearch('');
    } catch (error) {
      dispatch(failure(error?.data?.message || MESSAGES.GENERAL_ERROR));
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  return (
    <BootstrapDialog
      onClose={handleCloseModal}
      aria-labelledby="customized-dialog-title"
      open={openModal}
      className="campaignDeleteModal"
    >
      <IconButton aria-label="close" onClick={handleCloseModal} className="crossIcon">
        <img src={DetailsCrossCIcon} alt="crossIcon" />
      </IconButton>
      <DialogContent dividers className="campaignDeleteModalContent">
        <img src={ContactDetailsDeleteCIcon} alt="delete" />
        <Box className="deleteHeadings">
          <Typography gutterBottom variant="h4">
            {stepDelete
              ? MESSAGES.COMPAIGNS.ACTIONS.MODAL.DELETE_HEADING_STEP
              : MESSAGES.COMPAIGNS.ACTIONS.MODAL.DELETE_HEADING}
          </Typography>
          <Typography gutterBottom>
            {stepDelete
              ? MESSAGES.COMPAIGNS.ACTIONS.MODAL.DELETE_DESCRIPTION_STEP
              : MESSAGES.COMPAIGNS.ACTIONS.MODAL.DELETE_DESCRIPTION}
          </Typography>
        </Box>
        <Box className="campaignDeleteModalBtns">
          <OlcButton variant="secondary" onClick={handleCloseModal}>
            {MESSAGES.COMPAIGNS.ACTIONS.MODAL.CANCEL_BUTTON_DELETE}
          </OlcButton>
          <OlcButton
            variant="primary"
            onClick={stepDelete ? onSubmit : deleteExistingCategory}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress
                sx={{
                  color: '#fff !important',
                  width: '25px !important',
                  height: '25px !important',
                }}
              />
            ) : (
              MESSAGES.COMPAIGNS.ACTIONS.MODAL.SUBMIT_BUTTON_DELETE
            )}
          </OlcButton>
        </Box>
      </DialogContent>
    </BootstrapDialog>
  );
};

export default ActionsModal;
